// News & Recent Activities data (paraphrased summaries of published coverage)
export const NEWS = [
  {
    id: 'erie-news-now-walnut-creek',
    title: 'Strong Message Delivered During Drug and Alcohol Awareness Program',
    author: 'Mike Ruzzi',
    source: 'Erie News Now',
    sourceUrl: 'https://www.erienewsnow.com',
    date: 'Jun 1, 2026',
    updated: 'Jun 1, 2026',
    location: 'Walnut Creek Middle School — Erie, PA',
    cover:
      'https://images.unsplash.com/photo-1523240795612-9a054b0db644?auto=format&fit=crop&w=1600&q=80',
    tags: ['Featured', 'Erie County', 'Middle School'],
    summary:
      'Erie News Now reported on retired Erie Police Detective Joe Kress delivering a powerful drug and alcohol awareness presentation to Walnut Creek Middle School students.',
    paragraphs: [
      'Erie News Now recently covered a presentation by retired Erie Police Detective Joe Kress at Walnut Creek Middle School, where students listened in silence to a candid message about the realities of drug and alcohol abuse.',
      'Since retiring from the force in 2008, Kress has devoted much of his time to bringing his drug awareness program directly into schools across the region — continuing work he began during his years in law enforcement.',
      'The presentation featured recorded testimony from two former addicts. One of them recorded her story in 2020 and passed away from an overdose in Columbus, Ohio a few years later. Her voice, along with other former Erie County residents, now lives on as a warning to the next generation of students.',
      'Their testimonies describe getting hooked on drugs as young teenagers, battling addiction for decades, and ultimately losing that fight at a young age — a sobering reminder of what is at stake, and why programs like this one matter.',
    ],
    highlights: [
      'Presented at Walnut Creek Middle School (Erie, PA)',
      'Includes recorded testimony from two former addicts',
      'One participant later passed away from an overdose in Columbus, OH',
      'Features video interviews with former Erie County residents',
      'Reported by Mike Ruzzi for Erie News Now',
    ],
  },
];
